module.exports = "app.service('EspaRoute',['Resty',function(Resty){return Resty('espa_routes');}]);"